<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/north-face/products/*', { eager: true });

useHead({});

const products = [
	{
		title: 'ThermoBall™ Trekker Jacket',
		src: imagesGlob['../../images/brands/north-face/products/thermoball-trekker-jacket.jpg'].default
	},
	{
		title: 'Apex DryVent™ Jacket',
		src: imagesGlob['../../images/brands/north-face/products/apex-dryvent-jacket.jpg'].default
	},
	{
		title: 'Fall Line Backpack',
		src: imagesGlob['../../images/brands/north-face/products/fall-line-backpack.jpg'].default
	},
	{
		title: 'Glacier 1/4-Zip Fleece',
		src: imagesGlob['../../images/brands/north-face/products/glacier-14zip-fleece.jpg'].default
	},
	{
		title: 'Mountain Peaks 1/4-Zip Fleece',
		src: imagesGlob['../../images/brands/north-face/products/mountain-peaks-14zip-fleece.jpg'].default
	},
	{
		title: 'Ridgewall Soft Shell Vest',
		src: imagesGlob['../../images/brands/north-face/products/ridgewall-soft-shell-vest.jpg'].default
	},
	{
		title: 'Sweater Fleece Jacket',
		src: imagesGlob['../../images/brands/north-face/products/sweater-fleece-jacket.jpg'].default
	},
	{
		title: 'Ultimate Trucker Cap',
		src: imagesGlob['../../images/brands/north-face/products/ultimate-trucker-cap.jpg'].default
	},
	{
		title: 'Skyline Full-Zip Fleece Jacket',
		src: imagesGlob['../../images/brands/north-face/products/skyline-fullzip-fleece-jacket.jpg'].default
	},
]
</script>

<template lang="pug">
.page.page--brand.north-face
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/north-face/logo.png')
				h1 Custom North Face
			.image
				img(src='@static/images/brands/north-face/hero.jpg' alt="Woman wearing North Face apparel and accessories, standing with her back turned on a rocky lookout at dusk, overlooking a beautiful sky and natural landscape.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Never Stop Exploring
				p Rooted in a legacy of exploration and innovation, custom North Face by Swagger delivers performance-driven gear built for the modern adventurer. Whether you're trekking through alpine terrain or navigating city streets, every piece is engineered to perform and crafted to last. With sustainability at the core of its mission, The North Face blends technical function with timeless style. Designed for those who seek more from what they wear, this is gear that goes the distance.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom North Face ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="north-face")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/north-face/banner.avif' alt="North Face gear on a counter in Renewed packaging labeled 'WASTE LESS EXPLORE MORE,' highlighting the brand’s commitment to sustainability and responsible adventure.")
			.section__content
				.copy
					h2 BUILT RESPONSIBLY. WORN BOLDLY.
					p The North Face is deeply committed to protecting the places we explore. With sustainability woven into every step of the process, they’re pushing boundaries through circular design, thoughtful sourcing, and climate-conscious innovation. From collections like ThermoBall™ Eco made from recycled materials, to programs that give gear a second life, they’re turning waste into warmth and reimagining what responsible adventure looks like.
		
		section.section.section--foot
			.bg
			.section__content
		
</template>

<style></style>